import { AppSettingsType } from "AppSettings";
import { isExternalOrReadonlyAdmin } from "form/util";
import { PremiumType, UserRole, VehicleAzure } from "types/types";

export type PolicyDataLine = {
  premiumType: PremiumType;
  isPolicyIssuedField: keyof VehicleAzure;
  policyNumberField: keyof VehicleAzure;
};

// main lines whose policy number and document date can be set (backend SetVehiclePremiumPolicyData);
// HULL covers Hull and Hull-Basic, each *_PRORATA covers the whole line (prorata and closing date)
export const POLICY_DATA_LINES: PolicyDataLine[] = [
  {
    premiumType: PremiumType.MTPL,
    isPolicyIssuedField: "mtplIsPolicyIssued",
    policyNumberField: "mtplPolicyNumber",
  },
  {
    premiumType: PremiumType.HULL,
    isPolicyIssuedField: "hullIsPolicyIssued",
    policyNumberField: "hullPolicyNumber",
  },
  {
    premiumType: PremiumType.FLEETLEGAL_PRORATA,
    isPolicyIssuedField: "fleetLegalIsPolicyIssued",
    policyNumberField: "fleetLegalPolicyNumber",
  },
  {
    premiumType: PremiumType.HULL_ON_LAND_PRORATA,
    isPolicyIssuedField: "hullOnLandIsPolicyIssued",
    policyNumberField: "hullOnLandPolicyNumber",
  },
  {
    premiumType: PremiumType.MACHINERY_BREAKDOWN_PRORATA,
    isPolicyIssuedField: "machineryBreakdownIsPolicyIssued",
    policyNumberField: "machineryBreakdownPolicyNumber",
  },
];

// lines of the fleet's country which the vehicle currently has - the Azure Search row has
// <line>IsPolicyIssued = null exactly when the line has no current (non-cancelled) premium
export const getPolicyDataLines = (
  fleetAppSettings: AppSettingsType | null | undefined,
  vehicle: Partial<VehicleAzure> | null | undefined,
): PolicyDataLine[] => {
  if (!vehicle) return [];
  const countryPremiumTypes = fleetAppSettings?.VEHICLE_PREMIUM_TYPES ?? [];
  return POLICY_DATA_LINES.filter(
    (line) =>
      countryPremiumTypes.includes(line.premiumType) &&
      vehicle[line.isPolicyIssuedField] !== null &&
      vehicle[line.isPolicyIssuedField] !== undefined,
  );
};

// menu entry is not offered for LT fleets, external / read-only users and TEMP vehicles
export const isSetPolicyNumberAndDocumentDateHidden = (
  fleetAppSettings: AppSettingsType | null | undefined,
  userRole: UserRole | null,
  isTEMP: boolean,
) =>
  !fleetAppSettings ||
  fleetAppSettings.COUNTRY_CODE === "Country.LT" ||
  isExternalOrReadonlyAdmin(userRole) ||
  isTEMP;
